import Tippy from "@tippyjs/react";
import React, { useEffect, useState } from "react";
import Icon1 from "../icons/Icon";

function MLTFGPT3({
  label,
  value = "",
  mandatory = false,
  noborder = false,
  type = "text",
  mandatory_length = type === "phone" ? 14 : null,
  mandatory_characters = type === "email" ? ["@", "."] : [],
  min = 0,
  max = null,
  onChange = () => {},
  className = "",
  autoComplete = "off",
  transparent = false,
  onEnter = () => {},
  focusOnStart = false,
  disabled = false,
  items = [],
  rows = 4,
  useSuggestedValue = () => {},
}) {
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      onEnter();
    }
  };

  const [autoFilled, setAutoFilled] = useState(false);
  const [hovering, setHovering] = useState(false);
  useEffect(() => {
    const input = document.getElementById(`input-${label}`);

    if (input) {
      setTimeout(() => {
        input.style.backgroundColor = "white"; // Ensure background resets
        input.style.transition = "background-color 5000s ease-in-out 0s"; // Prevent instant reset
      }, 100);
    }
  }, []);

  const [focus, setFocus] = useState(false);
  const [suggestedValue, setSuggestedValue] = useState(null);

  const handleChange = (ee) => {
    let formatted = forceformat(ee.target.value, type);
    let e = { ...ee, target: { ...ee.target, value: formatted } };
    onChange(e);

    const found = items.find((item) =>
      item.label.toLowerCase().includes(e.target.value.toLowerCase())
    );

    if (found && e.target.value?.length > 0) {
      setSuggestedValue(found);
    } else {
      setSuggestedValue(null);
    }
  };

  let has_value = value !== null && value !== undefined && value !== "";
  let missing_mandatory_characters = mandatory_characters.some(
    (char) => !value.includes(char) && has_value
  );
  let mandatory_length_disrespect =
    mandatory_length && value.length !== mandatory_length && has_value;
  let mandatory_disrespect =
    (mandatory && !value && !focus) ||
    missing_mandatory_characters ||
    mandatory_length_disrespect;
  let border_color = mandatory_disrespect
    ? "border-red-300"
    : focus
    ? "border-blue-300"
    : "border-gray-200";

  return (
    <div
      onMouseEnter={() => setHovering(true)}
      onMouseLeave={() => setHovering(false)}
      onFocus={() => setFocus(true)}
      onBlur={() => setFocus(false)}
      className={`w-full h-fit min-h-fit relative flex flex-row select-none ${
        has_value ? "items-end" : "items-center py-1"
      } text-black ${className} 
      w-full
      px-2  
      
     
      rounded-xl
      ${
        noborder
          ? ""
          : focus
          ? "border-2 outline-1 outline-blue-100"
          : mandatory_disrespect
          ? "border-2 outline-1 outline-red-100"
          : "border    "
      }
      ${border_color}
      
      outline-none
      transition
      ease-in-out
      duration-150
      ${
        disabled
          ? "bg-neutral-100 text-shadow_25"
          : transparent
          ? "bg-transparent font-semibold"
          : "bg-white"
      }      
    `}
    >
      {has_value && (
        <div
          className={`absolute ${
            focus ? "text-blue-400 font-medium" : "text-gray-300"
          } ${
            disabled ? "bg-neutral-100" : "bg-white"
          }  py-1 pr-1 top-0 rounded-b-md   text-h6 `}
        >
          {label}
        </div>
      )}
      {(mandatory_length_disrespect || missing_mandatory_characters) && (
        <div
          className={`absolute top-0 right-0 rounded-bl-lg px-1 pb-0.5 rounded-tr-lg bg-red-300 text-white  text-h6 `}
        >
          Champ invalide
        </div>
      )}
      {mandatory && !has_value && (
        <div
          className={`absolute top-0 right-0 rounded-bl-lg px-1 pb-0.5 rounded-tr-lg bg-red-300 text-white  text-h6 `}
        >
          Champ obligatoire
        </div>
      )}

      <textarea
        id={`input-${label}`}
        disabled={disabled}
        type={type} // Force text input type to avoid unwanted number input behavior
        min={min}
        max={max}
        rows={rows}
        placeholder={label}
        value={value === null ? "" : value}
        autoFocus={focusOnStart}
        onKeyDown={handleKeyDown}
        onChange={handleChange}
        autoComplete={autoComplete}
        className={`
          w-full
          bg-transparent
          rounded-xl
py-1 ${value ? "pt-5 " : ""}      
          resize-none
          outline-none
          transition
          ease-in-out
          duration-150
        `}
        style={{
          fontSize: "14px",
        }}
      />
    </div>
  );
}

export default MLTFGPT3;

function forceformat(value, type) {
  if (type === "phone") {
    // Remove all non-numeric characters
    // Add a spaces after every 2 characters
    // Remove any spaces at the end
    // Limit to 14 characters
    return value
      .replace(/\D/g, "")
      .replace(/(\d{2})/g, "$1 ")
      .replace(/\s+$/, "")
      .slice(0, 14);
  }
  return value;
}
